module.exports = __webpack_public_path__ + "img/one-line-vehicle-row-ford.6f33907f.png";